module.exports = __webpack_public_path__ + "img/flying-kid_old.cbc51594.png";